export default __webpack_public_path__ + "static/media/logo512.4e9345d8.png";